import { render, staticRenderFns } from "./CompanyIndex.vue?vue&type=template&id=9b39c952"
import script from "./CompanyIndex.vue?vue&type=script&lang=js"
export * from "./CompanyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b39c952')) {
      api.createRecord('9b39c952', component.options)
    } else {
      api.reload('9b39c952', component.options)
    }
    module.hot.accept("./CompanyIndex.vue?vue&type=template&id=9b39c952", function () {
      api.rerender('9b39c952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyIndex.vue"
export default component.exports